<template>
  <div>
    <page-header
      title="Edit user"
      :back="true"
    />
    
    <form-renderer 
      :fieldData="fields"
      :formDisabled="formDisabled"
      :onSubmit="handleSubmit"
      :styler="{ groupHeaderColor: `#${colors.maroon}` }"
      :formMessage="formMessage"
    />
  </div>
</template>

<script>
import FormRenderer from "../../components/FormRenderer";
import PageHeader from '../../components/PageHeader.vue';
import colors from '../../constants/colors'
export default {
  name: "editUserData",
  data: function() {
    const makeField = FormRenderer.methods.makeFieldItem
    const getUserData = this.$store.getters.user;
    const { username, signOff, disclaimer, email, number, site, address } = getUserData;
    const companyName = getUserData["company name"] || "";

    let fields = [
      makeField( "username", "Username", "General info", "long", username, 'text', true),
      makeField( "address", "Business address", "Business information", 'long', address),
      makeField( "company name", "Company name", "Business information", null, companyName),
      makeField( "number", "Phone number", "Business information", null, number),
      makeField( "email", "Email address", "Business information", null, email),
      makeField( "site", "Website", "Business information", null, site),

    ]
    if (this.$store.getters.hasInvoiceAccess) {
      fields.push(makeField( "signOff", "Sign off text", "Invoice data", "long", signOff, 'textarea'))
      fields.push(makeField( "disclaimer", "Disclaimer text", "Invoice data", "long", disclaimer, 'textarea'))
    }

    return {
      colors,
      fields,
      formDisabled: false,
      formMessage: { message: null, type: 'success' }
    };
  },
  components: { FormRenderer, PageHeader },
  computed: {},
  methods: {
    async handleSubmit(formData) {
      this.formDisabled = true;
      const result = await this.$store.dispatch('updateUserData', formData)
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      if(result && result.success) {
        this.formMessage = { message: 'Data updated successfully', type:'success' }
      } else {
        this.formMessage = {
          message: 'Error submitting form',
          type: 'error'
        }
      }
      this.formDisabled = false
    }
  }
};
</script>

